import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field } from 'redux-form';
import PointsWithLimitUniquenessConstraintField from './PointsWithLimitUniquenessConstraintField';

const PointsWithLimitUniquenessConstraint = ({ field, applications, max, usedValues, groupByDistricts, districts }) => (
  <Field
    name={field}
    component={PointsWithLimitUniquenessConstraintField}
    values={applications}
    usedValues={usedValues}
    max={max}
    groupByDistricts={groupByDistricts}
    districts={districts}
  />
);

PointsWithLimitUniquenessConstraint.propTypes = {
  field: PropTypes.string.isRequired,
  applications: PropTypes.array.isRequired,
  max: PropTypes.number.isRequired,
  usedValues: PropTypes.array.isRequired,
  groupByDistricts: PropTypes.bool.isRequired,
  districts: PropTypes.array,
};

function mapStateToProps(state) {
  return {
    usedValues: state.form.budgetVoteForm.values ? state.form.budgetVoteForm.values.votes.filter(v => v.value).map(v => v.value) : [],
  };
}

export default connect(mapStateToProps)(PointsWithLimitUniquenessConstraint);



// WEBPACK FOOTER //
// ./src/components/budget/types/PointsWithLimitUniquenessConstraint.js